import { createClasses } from 'src/theme/create-classes';

// ----------------------------------------------------------------------

export const lightboxClasses = {
  root: createClasses('lightbox__root'),
};
